import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'hammerjs';


import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { initializeApp } from 'firebase/app';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

if (Capacitor.isNativePlatform()) {
  // iOS: WebView beginnt UNTER der Notch
  StatusBar.setOverlaysWebView({ overlay: false });

  // Android: Status-Bar-Farbe angleichen
  StatusBar.setBackgroundColor({ color: '#000000' });
}

initializeApp(environment.firebase);


bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
